<div class="middle-box text-center animated fadeInDown">
  <tig-alert></tig-alert>
  <h1>500</h1>
  <h3 class="font-bold">{{"internal_error_title"|translate}}</h3>
  <div *ngIf="STR_reason != null;else defaultError" class="error-desc">
    {{STR_reason|translate}}<br/>
  </div>
  <ng-template class="error-desc" #defaultError>
    {{"internal_error_description"|translate}}<br/>
  </ng-template>
  <br>
  <button type="button" class="btn btn-sm btn-white btn-block" (click)="retry()">{{'oLogin.sPlaceholder'|translate}}</button>
</div>
